import { render, staticRenderFns } from "./LeadWorkflowDetails.vue?vue&type=template&id=b54bf974&scoped=true"
import script from "./LeadWorkflowDetails.vue?vue&type=script&lang=ts"
export * from "./LeadWorkflowDetails.vue?vue&type=script&lang=ts"
import style0 from "./LeadWorkflowDetails.vue?vue&type=style&index=0&id=b54bf974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54bf974",
  null
  
)

export default component.exports